var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "MyDrag",
    {
      key: "2",
      staticClass: "drag-resize-container",
      attrs: {
        id: "drag-icon",
        x: _vm.initialX,
        y: _vm.initialY,
        w: 90,
        h: 100,
      },
      on: {
        "update:x": function ($event) {
          _vm.initialX = $event
        },
        "update:y": function ($event) {
          _vm.initialY = $event
        },
      },
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { staticClass: "aiIconBox" }, [
          _c("img", {
            attrs: { src: require("@/assets/image/aiIcon.gif"), alt: "" },
          }),
          _c("div", { staticClass: "text" }, [
            _c("div", [_vm._v("我的")]),
            _c("div", [_vm._v("AI管家")]),
          ]),
          _c(
            "div",
            {
              staticClass: "closeBtnBox",
              on: {
                mouseover: function ($event) {
                  _vm.showClose = true
                },
                mouseleave: function ($event) {
                  _vm.showClose = false
                },
              },
            },
            [
              _vm.showClose
                ? _c("i", {
                    staticClass: "el-icon-error closeBtn",
                    on: {
                      mouseup: function ($event) {
                        $event.stopPropagation()
                        return _vm.onhandleClose.apply(null, arguments)
                      },
                    },
                  })
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }